import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/categories';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-4xl px-4 md:px-6 text-center">
        <div className="rounded-lg bg-primary-50 border border-primary-200 px-6 py-12 md:px-12 md:py-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto mb-8">
            {t('cta.subtitle')}
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base" />
            </span>
            {t('cta.button')}
          </a>
        </div>
      </div>
    </section>
  );
}